import React from "react";
import "./index.css";
import { Spin, Typography } from "antd";

type Props = {
  value: number | string;
  label: string;
  sublabel?: string;
  variant?: "primary" | "secondary";
  size?: "small" | "medium" | "large";
  loading?: boolean;
  comingSoon?: boolean;
};

const { Text } = Typography;

// TODO: Remove comingSoon prop to activate this component
const ActivityDisplay: React.FC<Props> = ({
  value,
  label,
  sublabel,
  variant = "primary",
  size = "medium",
  loading = false,
  comingSoon = false,
}) => {
  return (
    <Spin spinning={!comingSoon && loading} wrapperClassName="activity-spin">
      <div className="relative">
        <div
          className={`activity-display-container activity-display--${variant} activity-display--${size} ${comingSoon ? "activity-display--disabled" : ""}`}
        >
          <div className="activity-value">{`${comingSoon ? "-" : value}`}</div>
          <div className="activity-content">
            <div className="activity-label">{label}</div>
            {sublabel && <div className="activity-label">{sublabel}</div>}
          </div>
        </div>
        {comingSoon && (
          <div className="absolute inset-0 z-10 flex items-center justify-center bg-slate-900/5 backdrop-blur-[1px] rounded-[8px] opacity-0 hover:opacity-100 transition-opacity duration-200">
            <div className="bg-white px-4 py-2 rounded-full opacity-90">
              <Text>Coming Soon</Text>
            </div>
          </div>
        )}
      </div>
    </Spin>
  );
};

export default ActivityDisplay;
